<!-- A plain thumbnail for a design: it renders straight away (no intersection tracking - see CatalogPreviewEnv for that), with the browser left to lazy-load the image -->

<template>
  <div class="design" v-bind:class="{ loading }">
    <template v-if="design">
      <template v-if="isVideo && !still">
        <!--
        Safari plays back mp4 sources inside picture / img elements. In low-power mode, iOS will not autoplay any videos, so this is a useful trick to work around that. It may better to simply use the webp version of the video in all cases (that's what Giphy appears to do), but the mp4 version is higher quality with better compression. Some discussion here: https://developer.apple.com/forums/thread/690523?page=2
        -->
        <picture v-if="IS_IOS_SAFARI">
          <source type="video/mp4" :srcset="base + design.key + '_270x378.mp4'">
          <source type="image/webp" :srcset="base + design.key + '_200x280.webp'">
          <img
            class="d-block"
            width="100%" type="image/jpeg" loading="lazy" decoding="async"
            :src="base + design.key + '_poster_270x378.jpg'"
            :alt="alt"
            @load="end"
            @error="end"
            @abort="end"
          />
        </picture>
        <video
          v-else
          class="d-block"
          width="100%" playsinline autoplay muted loop
          :poster="base + design.key + '_poster_270x378.jpg'"
          :src="base + design.key + '_270x378.mp4'"
          :aria-label="alt"
          @loadeddata="end"
          @error="end"
          @abort="end"
        />
      </template>
      <img
        v-else
        class="d-block"
        width="100%" loading="lazy" decoding="async"
        :src="base + design.key + (isVideo ? '_poster_270x378.jpg' : '_270x378.jpg')"
        :alt="alt"
        @load="end"
        @error="end"
        @abort="end"
      />
    </template>
  </div>
</template>

<style scoped>
.design {
  aspect-ratio: 5 / 7;
  overflow: hidden;
  word-break: break-all;
  width: 100%;
}
</style>

<script>
export default {
  name: 'catalog-preview-eager',

  props: {
    design: Object,
    // Show a video design as its poster frame instead of playing it - for small or numerous thumbnails, where dozens
    // of looping clips (which iOS decodes as animated images) are what makes a long list grind
    still: Boolean
  },

  data() {
    return {
      loading: true
    };
  },

  computed: {
    isVideo() {
      return this.design.type == 'video/mp4';
    },

    alt() {
      return 'Ellacard card design' + (this.design.name ? ': ' + this.design.name : '');
    }
  },

  created() {
    this.base = 'https://cdn.ellacard.com/';
  },

  methods: {
    end() {
      this.loading = false;
      this.$emit('loaded');
    }
  }
}
</script>
